import React from "react";
import "./ToolTip.css";

const ToolTip = ({ children, text, className = "" }) => (
  <div className={`${className} tooltip-container`}>
    {children}
    <span className="tooltip-text">{text}</span>
  </div>
);

export default ToolTip;
